
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 52 52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.266 32.664a5.09 5.09 0 007.243 7.153L26 33.244l6.49 6.573a5.09 5.09 0 107.244-7.153L33.154 26l6.58-6.664a5.09 5.09 0 10-7.243-7.153L26 18.756l-6.491-6.573a5.09 5.09 0 00-7.244 7.153L18.846 26l-6.58 6.664z","fill":"#EB4942"}})])
          )
        }
      }
    